module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Wi-fi-46f21f389a7e815c4289594e1555d29f.svg";